import React from 'react';
import { Page } from '../Page';
import { Moon, Activity, Droplet } from 'lucide-react';
export function SupplementMagnesium() {
  return <Page pageNumber={31} variant="light" data-id="element-3530" data-mp="90u50wp5susb">
      <div className="flex h-full gap-10" data-id="element-3531" data-mp="msh4t6ib8lfu">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3532" data-mp="mul6riwnfadh">
          <img src="https://cdn.magicpatterns.com/uploads/gCYzSDztr2JWuKYmAKzahh/pasted-image.png" alt="Thorne Magnesium Glycinate" className="w-full max-w-[280px] object-contain" data-id="element-3533" data-mp="huflckgz2k3u" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3534" data-mp="43afh0n0gvl2">
          <div className="mb-6 pt-4" data-id="element-3535" data-mp="3zwfu05qf0hb">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3536" data-mp="3v8aizep65ktq">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3537" data-mp="1fjimbe9h6t2j">
              Magnesium Glycinate
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3538" data-mp="1gajr5olrcw8i">
              Sleep, digestion, and metabolic support
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3539" data-mp="1l7thr7kvvdxx" />
          </div>

          <div className="mb-8" data-id="element-3540" data-mp="1q87qysy80txj">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3541" data-mp="1q991mwbbreeq">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3542" data-mp="xk215rsb8equ">
              Magnesium glycinate does triple duty for GLP-1 users: supports
              sleep quality, relieves constipation (a very common GLP-1 side
              effect), and enhances insulin sensitivity. The glycinate form is
              calming, well-absorbed, and gentle on the stomach.
            </p>
          </div>

          <div className="mb-8" data-id="element-3543" data-mp="etu67wyrkulq">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3544" data-mp="esj401kyvuwq">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3545" data-mp="jqud2a3fu1dw">
              <li className="flex gap-2" data-id="element-3546" data-mp="bqo1urqsknjw">
                <Moon className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3547" data-mp="bpmrkphlo538" />
                <span data-id="element-3548" data-mp="6s3alhtipe7l">
                  Promotes relaxation and deeper sleep, critical for weight loss
                  success
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3549" data-mp="gi62feowkm4c">
                <Droplet className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3550" data-mp="gkiu4jkgqaul" />
                <span data-id="element-3551" data-mp="3oyrfp7oki1d9">
                  Relieves constipation by drawing water into the intestines
                  (gentle, non-stimulant)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3552" data-mp="2s2kgzx23ekp">
                <Activity className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3553" data-mp="2oyd5toao2pt" />
                <span data-id="element-3554" data-mp="3tvrcst3fvts8">
                  Supports insulin sensitivity and healthy blood sugar
                  metabolism
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3555" data-mp="197wivue0c03m">
                <span className="text-tealslate shrink-0" data-id="element-3556" data-mp="196tupu82kbre">•</span>
                <span data-id="element-3557" data-mp="1gpkvrsgn25s6">
                  120mg per capsule with flexible dosing (1-3 caps) based on
                  individual needs
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3558" data-mp="17r9921iw7s50">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3559" data-mp="17saloafk4mou">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3560" data-mp="1bs1gqqc49oz6">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3561" data-mp="24g73fimqdo1n">
                <strong data-id="element-3562" data-mp="24fp2w9t1cnnx">1-3 capsules daily</strong>. Take in the evening for
                sleep support
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3563" data-mp="1qmzdrwi7n2ml">
                120mg magnesium per capsule • Start with 1 cap and adjust as
                needed
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3564" data-mp="2idvejyqzxgti">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3565" data-mp="2n6y8i7zoqsa8" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3566" data-mp="uhz1n6b7lqu9">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}